import { get, put } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function getPartnerMonthlyObligations(documentId, siteId, partnerId) {
  return get(`${url}/document-partners/${documentId}/${siteId}/${partnerId}/monthly-obligations`);
}

export function updateDocumentPartnerMonthlyObligations(data) {
  return put(`${url}/document-partners/${data.documentId}/${data.siteId}/${data.partnerId}/monthly-obligations`, {
    documentId: data.documentId,
    siteId: data.siteId,
    partnerId: data.partnerId,
    values: data.values
  });
}

export function updateDocumentAssociatedPartnerMonthlyObligations(data) {
  return put(`${url}/document-partners/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/monthly-obligations`, {
    documentId: data.documentId,
    siteId: data.siteId,
    partnerId: data.partnerId,
    values: data.values
  });
}
